import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import mbxGeocoding from '@mapbox/mapbox-sdk/services/geocoding';
import { sortBy } from 'lodash';
import AnimateHeight from 'react-animate-height';

// Components
import Map from './LocatorMap';
import MapResults from './LocatorResults';
import MapFilter from './LocatorFilter';

// Helpers
import { scrollToElement } from '../../../lib/utilities';

// Config
import { MAPBOX_API_KEY } from '../../../config';
import $ from 'jquery';

const geocodingService = mbxGeocoding({ accessToken: MAPBOX_API_KEY });

class Locator extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentPlace: null,
      userPosition: [],
      hasLoadMore: false,
      hasSearched: false,
      isLoading: false,
      places: [],
      placesDetails: {},
      radius: this.props.defaultRadius || '8000',
      zip: '',
      dealerTypeFilters: [],
      showMapFilters: true
    };
    this.handleInactiveMapClick = this.handleInactiveMapClick.bind(this);
    this.setCurrentPlace = this.setCurrentPlace.bind(this);
    this.getDetails = this.getDetails.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.toggleFiltersVisibility = this.toggleFiltersVisibility.bind(this);
  }

  render() {
    const {
      currentPlace,
      hasLoadMore,
      hasSearched,
      isLoading,
      radius,
      zip
    } = this.state;
    $('#where-to-buy-faq-accordion').hide();
    const { activeLabel, directoryUrl, showFilters } = this.props;
    const places = this.getPlaces();

    return (
      <Fragment>
        <section className="section u--padding-top-0">
          <div className="container where-to-buy-container">
            <form
              className={`where-to-buy-form page-header__search-form page-header__search-form--simple page-header__search-form--w-border u--margin-left-0 u--margin-bottom-50-xs ${
                !hasSearched ? 'page-header__search-form--focus' : ''
              }`}
              onSubmit={(event) => {
                event.preventDefault();
                this.search();
              }}
            >
              <div className="form__field form__input-group">
                <input
                  ref={(input) => (this.input = input)}
                  type="search"
                  className="form__input u--padding-right-0-xs u--padding-left-35-xs"
                  placeholder="Enter Your Zip Code"
                  value={zip}
                  onChange={(event) =>
                    this.setState({ zip: event.target.value })
                  }
                />
                {this.props.hasRadialSearch ? (
                  <div className="form__select">
                    <select
                      value={radius}
                      onChange={(event) =>
                        this.setState({ radius: event.target.value })
                      }
                    >
                      <option value="8000">5 miles</option>
                      <option value="16000">10 miles</option>
                      <option value="32000">20 miles</option>
                      <option value="80000">50 miles</option>
                      <option value="160000">100 miles</option>
                    </select>
                  </div>
                ) : null}
                <button type="submit" className="btn btn--red">
                  <span className="btn__content">
                    <span className="btn__angle" />
                    <span className="btn__text">Search</span>
                  </span>
                </button>
              </div>
            </form>
            <div
              className={classnames('map', { 'map--inactive': !hasSearched })}
              onClick={this.handleInactiveMapClick}
            >
              <div className="map__container" ref={(map) => (this.map = map)}>
                <Map
                  places={places}
                  currentPlace={currentPlace}
                  setCurrentPlace={this.setCurrentPlace}
                />
                <div
                  className={classnames('map__zip-instructions', {
                    'not--searched': !hasSearched
                  })}
                >
                  <p>
                    To find{' '}
                    {activeLabel == 'dealer'
                      ? 'an Equipment Dealer'
                      : 'a Propane Supplier'}
                    , enter your Zip Code Above
                  </p>
                </div>
                <div className="map__sidebar-footer map__sidebar-footer-mobile">
                  <a
                    href={directoryUrl}
                    className="callout-map module-hover-root"
                  >
                    <strong>Don't see your business?</strong>
                    <span>
                      Learn how to add it to the directory{' '}
                      <span className="arrow arrow--white" />
                    </span>
                  </a>
                </div>
              </div>
              <div className="map__sidebar">
                {showFilters && hasSearched && places.length > 0 && (
                  <div className="map__sidebar-filter__container">
                    <header
                      className={classnames('map__sidebar-filter__header', {
                        [`toggle__switch--on`]: this.state.showMapFilters
                      })}
                      onClick={() => this.toggleFiltersVisibility()}
                    >
                      Filter By Equipment Type <span className="caret" />
                    </header>
                    <AnimateHeight
                      duration={300}
                      height={this.state.showMapFilters ? 'auto' : 0}
                      easing={'ease-in-out'}
                      className="map__sidebar-filters"
                    >
                      <MapFilter
                        places={places}
                        currentFilters={this.state.dealerTypeFilters}
                        handleFilterChange={this.handleFilterChange}
                      />
                    </AnimateHeight>
                  </div>
                )}
                <header className="map__sidebar-header">
                  Showing {places.length} Results
                </header>
                <div className="map__sidebar-body">
                  <MapResults
                    currentPlace={currentPlace}
                    getDetails={this.getDetails}
                    loadMore={this.loadMore}
                    places={places}
                    setCurrentPlace={this.setCurrentPlace}
                    hasLoadMore={hasLoadMore}
                  />
                </div>
                <footer className="map__sidebar-footer">
                  <a
                    href={directoryUrl}
                    className="callout-map module-hover-root"
                  >
                    <strong>Don't see your business?</strong>
                    <span>
                      Learn how to add it to the directory{' '}
                      <span className="arrow arrow--white" />
                    </span>
                  </a>
                </footer>
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    );
  }

  handleInactiveMapClick() {
    const { hasSearched } = this.state;

    if (!hasSearched) {
      scrollToElement(this.header, () => this.input.focus());
    }
  }

  handleFilterChange(type) {
    const filters = this.state.dealerTypeFilters.slice();

    // Add/Remove filter, depending on if it was previously present
    filters.includes(type)
      ? filters.splice(filters.indexOf(type), 1)
      : filters.push(type);

    this.setState({ dealerTypeFilters: filters });
  }

  toggleFiltersVisibility() {
    this.setState({
      showMapFilters: !this.state.showMapFilters
    });
  }

  setCurrentPlace(placeId) {
    if (placeId !== this.state.currentPlace) {
      this.setState({ currentPlace: placeId });
      scrollToElement(this.map);
    }
  }

  loadMore() {
    this.setState({
      hasLoadMore: false,
      isLoading: true
    });
    this.props.loadMore();
  }

  async search() {
    const { radius, zip } = this.state;
    if (!zip || zip.length < 4) {
      return;
    }
    this.setState({
      currentPlace: null,
      hasLoadMore: false,
      hasSearched: false,
      isLoading: true,
      places: []
    });
    try {
      const location = await this.geolocate(zip);
      this.props.searchNearby(
        location,
        radius,
        (error, places, hasMore = false) => {
          if (error) {
            this.setState({
              currentPlace: null,
              hasLoadMore: false,
              hasSearched: false,
              isLoading: false,
              places: []
            });
          } else {
            this.setState((state) => ({
              currentPlace: null,
              hasLoadMore: hasMore,
              hasSearched: true,
              isLoading: false,
              places: [...state.places, ...places],
              userPosition: location
            }));
            $('#where-to-buy-faq-accordion').show();
            scrollToElement(this.map);
          }
        }
      );
    } catch (e) {
      this.setState({
        currentPlace: null,
        hasLoadMore: false,
        hasSearched: false,
        isLoading: false,
        places: []
      });
    }
  }

  geolocate(address) {
    return new Promise((resolve, reject) => {
      geocodingService
        .forwardGeocode({
          query: address,
          limit: 1,
          countries: ['us']
        })
        .send()
        .then((response) => {
          if (response.body.features.length === 0) {
            reject('Unable to geolocate the provided zip code.');
          }
          resolve([
            response.body.features[0].center[0],
            response.body.features[0].center[1]
          ]);
        })
        .catch(() => {
          reject('Unable to geolocate the provided zip code.');
        });
    });
  }

  getPlaces() {
    const {
      places,
      placesDetails,
      userPosition,
      dealerTypeFilters
    } = this.state;

    // Add information
    const filteredPlaces = () => {
      if (!dealerTypeFilters.length) return places;

      return places.filter((place) => {
        const dealerType = place.dealerType.includes(', ')
          ? place.dealerType.split(', ')
          : place.dealerType.split();

        return dealerType.some((type) => dealerTypeFilters.includes(type));
      });
    };

    const placesWithDetails = filteredPlaces().map((place) => {
      // Add distance
      if (userPosition.length > 0) {
        place.distance = Number(
          (
            this.props.computeDistance(userPosition, place.location) / 1609.344
          ).toFixed(1)
        );
      }

      // Add details
      if (placesDetails.hasOwnProperty(place.id)) {
        place.hasDetails = true;
        place.details = Object.assign(
          {},
          place.details,
          placesDetails[place.id]
        );
      }

      return place;
    });

    // Sort by distance
    return sortBy(placesWithDetails, ['distance']);
  }

  async getDetails(placeId) {
    if (this.state.placesDetails.hasOwnProperty(placeId)) {
      return;
    }

    try {
      const place = await this.props.getDetails(placeId);

      if (placeId !== this.state.currentPlace) {
        scrollToElement(this.map);
      }

      this.setState((state) => ({
        currentPlace: placeId,
        placesDetails: Object.assign({}, state.placesDetails, {
          [placeId]: {
            formatted_address: place.formatted_address,
            formatted_phone_number: place.formatted_phone_number,
            opening_hours: place.opening_hours,
            website: place.website
          }
        })
      }));
    } catch (e) {
      // Handle error
    }
  }

  getUserPosition() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.setState({
          userPosition: [position.coords.longitude, position.coords.latitude]
        });
      });
    }
  }
}

Locator.propTypes = {
  activeLabel: PropTypes.string.isRequired,
  computeDistance: PropTypes.func.isRequired,
  directoryUrl: PropTypes.string.isRequired,
  getDetails: PropTypes.func.isRequired,
  searchNearby: PropTypes.func.isRequired
};

export default Locator;
